import React from "react";
import Attend from "../components/Attend";

function AttendPage() {
  return (
    <>
      <Attend />
    </>
  );
}

export default AttendPage;